import { CONTEXT_LOGIC_CONDITION_PREFIX } from '../contextValues'
import { parseLogicConditionSource } from '../logicRegEx'

/**
 * Checks if a given condition source is a context logic condition.
 * A context logic condition is identified by the first part of the condition source being '__context'.
 */
export const isContextLogicCondition = (
  conditionSourceInitial: string | undefined,
  options?: {
    isParsed?: boolean
    blockSeparator?: string
  }
) => {
  const { isParsed = false, blockSeparator = '/' } = options || {}

  const conditionSource = isParsed
    ? conditionSourceInitial
    : parseLogicConditionSource(conditionSourceInitial || '')

  if (typeof conditionSource === 'undefined') {
    return false
  }

  const parts = conditionSource.split(blockSeparator)

  if (parts[0] === CONTEXT_LOGIC_CONDITION_PREFIX) {
    return true
  }

  return false
}
